


























import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { Component, Vue } from "vue-property-decorator";
import { PartnerService } from "@/zh-website/src/views/partner/service";
import "../../../public/quill.snow.css";

@Component({
  components: {
    Banner
  }
})
export default class Details extends Vue {
  list = [];
  con = {} as any;
  bannerData = {
    font1: "",
    font2: "",
    font3: "",
    font4: "浙江华为专家网络",
    font5: "凝聚专业智慧 使能人才发展",
    button: "",
    style: {
      "background-image": 'url("' + require("../../assets/pic01.png") + '")',
      height: "420px"
    }
  };
  mounted() {
    this.getCaseDetail();
  }
  getCaseDetail() {
    PartnerService.getCooperationCaseDetail({
      cooperationCaseId: this.$route.params.id
    }).then((res: any) => {
      this.con = {
        field1: res.data.title,
        content1: res.data.content
      };
    });
    // const that = this;
    // const url = that.$store.state.homeUrl;
    // that.$ajax
    //   .get("/webAction/list/huawei_data?group=052", {})
    //   .then(function(res) {
    //     if (res.data.code == 1) {
    //       // that.nav = res.data.result.data;
    //       for (let x = 0; x < res.data.result.data.length; x++) {
    //         if (x + 1 == that.$route.params.aid) {
    //           that.title = res.data.result.data[x].field1;
    //           // that.con = res.data.result.data;
    //           that.fetchData2(res.data.result.data[x].id);
    //         }
    //       }
    //     }
    //   });
  }
  fetchData2(id) {
    // const that = this;
    // that.$ajax
    //   .get("/webAction/one/huawei_data", {
    //     params: { id: id }
    //   })
    //   .then(function(res) {
    //     if (res.data.code == 1) {
    //       that.con = res.data.result.data;
    //     }
    //   });
  }
  // async getCase () {
  //   const _this = this;
  //   try {
  //     const res = await _this.$ajax.get(
  //       "/webAction/list/huawei_data?group=052"
  //     );
  //     // _this.listCase = res.data.result.data;
  //     // _this.listCase.forEach(item => {

  //     // });
  //     for(var x =0;x<res.data.result.data.length;x++){
  //           if(x+1 == that.$route.params.aid){
  //           // that.title = res.data.result.data[x].field1;
  //               // that.con = res.data.result.data;
  //               that.getDetail(res.data.result.data[x].id)
  //           }
  //       }

  //     // _this.caseList = _this.listCase;
  //   } catch (err) {
  //     console.log(err)
  //     alert('请求出错！')
  //   }
  // },

  // async getDetail (id) {
  //   const _this = this;
  //   try {
  //     const res = await this.$ajax.get(
  //       "/webAction/one/huawei_data?id=" + _this.$route.params.aid
  //     );
  //    _this.con = res.data.result.data;
  //   console.log(res.data.result.data)
  //   } catch (err) {
  //     console.log(err)
  //     alert('请求出错！')
  //   }
  // },
}
